import _ from 'lodash'

export default class AnalyticsList {
  constructor(data) {
    this.data = data
  }

  call() {
    this.templateWrapper.innerHTML = this.parseTemplate()
  }

  parseTemplate () {
    _.templateSettings = {
      evaluate: /\{\{(.+?)\}\}/g,
      interpolate: /\{\{=(.+?)\}\}/g,
      escape: /\{\{-(.+?)\}\}/g,
    }

    let compiled = _.template(this.template.innerHTML)

    return compiled(this.data)
  }

  get templateWrapper() {
    return document.getElementById('nav-analytics')
  }

  get template() {
    return document.getElementById('template-analytics-list-view')
  }

  get calendarType() {
    return document.querySelector('[data-users--venues--stats-target="calendarType"]').value
  }
}